import Model from './Model'

export default class TagLead extends Model {
    resource() {
        return 'taglead'
    }

}
